// ConsumptionInputs.js – T0/T1/T2/T3/P/D ve toplam tüketim mantığını yöneten ortak component
import React, { useState, useEffect } from 'react';
import { Box, TextField, FormControlLabel, FormGroup, Switch } from '@mui/material';
import DecimalInput from './UiComponents/DecimalInput';

const ConsumptionInputs = ({
  validIndexTypes = [],
  values = {},
  onChange = () => { }
}) => {
  const [localValues, setLocalValues] = useState(values);

  const indexTypeMap = Object.fromEntries(validIndexTypes.map(t => [t.indexType, t]));


  useEffect(() => {
    setLocalValues(values);
  }, [values]);

  useEffect(() => {
    const hasOnlyT0 =
      validIndexTypes.some(t => t.indexType === 'T0') &&
      !validIndexTypes.some(t => ['T1', 'T2', 'T3'].includes(t.indexType));

  }, [validIndexTypes]);

  const handleValueChange = (type, value) => {
    const updated = { ...localValues, [type]: value };
    setLocalValues(updated);
    onChange(updated);
  };


  return (
    <Box>

      {['T0', 'T1', 'T2', 'T3', 'P', 'D'].map((type) => {
        const index = indexTypeMap[type];
        if (!index) return null;
        return (
          <Box key={type} marginY={1}>
            <DecimalInput
              label={index.indexName || type}
              value={localValues[type] !== undefined ? localValues[type] : ''}
              onChange={(val) => handleValueChange(type, val)}
              decimalSeparator="," maxDecimalDigits={3}
              unit={index.unit}
              required={index.meterReadingRequired}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ConsumptionInputs;
